import { NoResult } from "@/components/noResult";
import { useGetAllNotification } from "@/services/notifications/hooks/useGetAllNotification";
import useUpdateReadMessage from "@/services/notifications/hooks/useUpdateReadMessage";
import { ActionIcon, Alert, Button, Drawer, Group, LoadingOverlay, ScrollArea, Skeleton, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBell, IconX } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { faNumber } from "./format";
import classes from "./home.module.scss";

export default function NotificationsBell() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [opened, { open, close }] = useDisclosure(false);
  const { data, isLoading } = useGetAllNotification({ Count: 10000, Skip: 0, IsOpened: false });
  const { mutate, isLoading: isUpdating } = useUpdateReadMessage();
  const unread = data?.pages[0]?.count ?? 0;
  const items = data?.pages.flatMap((page) => page?.result ?? []) ?? [];

  const markRead = (id: number) =>
    mutate(id, { onSuccess: () => queryClient.invalidateQueries(["get-notification"]) });

  return (
    <>
      <button
        type="button"
        className={classes.iconButton}
        onClick={open}
        aria-label={unread ? `اعلان‌ها، ${faNumber(unread)} اعلان خوانده‌نشده` : "اعلان‌ها"}
      >
        <IconBell size={24} stroke={1.7} aria-hidden />
        {unread > 0 && <span className={classes.dot} />}
      </button>

      <Drawer
        opened={opened}
        onClose={close}
        title={
          <Group gap="xs">
            <IconBell stroke={1} />
            <Text>اعلان‌ها</Text>
          </Group>
        }
        radius="md"
        position="bottom"
        size="md"
      >
        <Stack h="350">
          <LoadingOverlay visible={isUpdating} loaderProps={{ type: "dots" }} />
          {isLoading ? (
            <Stack flex={1}>
              <Skeleton h={50} />
              <Skeleton h={50} />
              <Skeleton h={50} />
            </Stack>
          ) : items.length === 0 ? (
            <Stack flex={1}>
              <NoResult title="اعلانی برای نمایش موجود نیست" />
            </Stack>
          ) : (
            <ScrollArea flex={1}>
              {items.map((item) => (
                <Alert key={item.id} variant="light" mb="md">
                  <Group gap="xs" wrap="nowrap" align="start">
                    {!item.isOpened && (
                      <ActionIcon variant="light" size="xs" aria-label="خوانده شد" onClick={() => markRead(item.id || 0)}>
                        <IconX size={15} />
                      </ActionIcon>
                    )}
                    <Text size="xs">{item.message}</Text>
                  </Group>
                </Alert>
              ))}
            </ScrollArea>
          )}
          <Button variant="transparent" size="xs" onClick={() => navigate("/dashboard/profile/notifications")}>
            مشاهده همه
          </Button>
        </Stack>
      </Drawer>
    </>
  );
}
